import { render, staticRenderFns } from "./wax-carts-pkg-add.vue?vue&type=template&id=55587df2&"
import script from "./wax-carts-pkg-add.vue?vue&type=script&lang=js&"
export * from "./wax-carts-pkg-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55587df2')) {
      api.createRecord('55587df2', component.options)
    } else {
      api.reload('55587df2', component.options)
    }
    module.hot.accept("./wax-carts-pkg-add.vue?vue&type=template&id=55587df2&", function () {
      api.rerender('55587df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/wax-carts-pkg/wax-carts-pkg-add.vue"
export default component.exports